import React, { Component } from "react";

import "../App.css";
import "../css/style.css";
import "../css/bootstrap.css";
import logo from "../Assets/mathisadmission.png";

class Alphabet extends Component {
  constructor(props) {
    super(props);
    this.state = {
      random: Math.floor(Math.random() * 26),
      nbTab: [
        "A",
        "B",
        "C",
        "D",
        "E",
        "F",
        "G",
        "H",
        "I",
        "J",
        "K",
        "L",
        "M",
        "N",
        "O",
        "P",
        "Q",
        "R",
        "S",
        "T",
        "U",
        "V",
        "W",
        "X",
        "Y",
        "Z",
      ],
      number1: "",
      message: "C'est parti!",
      messageColor: "black-message",
    };
  }

  mySubmitHandlerAlphabet = (event) => {
    event.preventDefault();
    var good = this.state.random + 1;
    if (Number(good) === Number(this.state.number1)) {
      this.setState({ messageColor: "green-message" });
      this.setState({
        message:
          "Correct : " + this.state.nbTab[this.state.random] + " = " + good,
      });
    } else {
      this.setState({ messageColor: "red-message" });
      this.setState({
        message:
          "Erreur : " + this.state.nbTab[this.state.random] + " = " + good,
      });
    }
    var rand = Math.floor(Math.random() * 20);
    this.setState({ random: rand, number1: "" });
  };

  myChangeNumber1 = (event) => {
    this.setState({ number1: event.target.value });
  };

  render() {
    return (
      <div className="App">
        <div className="navigation">
          <img
            className="website-logo"
            src={logo}
            alt="Logo Mathis Admission"
          />
          <h1 className="website-title-text">Prepa Tage Mage</h1>
        </div>

        <div className="row" style={{ marginTop: 40, marginBottom: 40 }}>
          <div className="col">
            <h2 className="menu-principal-text">Alphabet</h2>
          </div>
        </div>

        <div className="container">
          <p>Trouvez le rang de cette lettre.</p>
          <p className={this.state.messageColor}>{this.state.message}</p>
          <form
            className="col"
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
            onSubmit={this.mySubmitHandlerAlphabet}
          >
            <label className="label-exos">
              {this.state.nbTab[this.state.random]} = ?{" "}
            </label>
            <div className="row" style={{ alignItems: "baseline" }}>
              <input
                className="input-number"
                type="number"
                name="number1"
                value={this.state.number1} 
                onChange={this.myChangeNumber1}
              />
            </div>
            <input
              className="validate-button"
              style={{ backgroundColor: "#00cfa4" }}
              type="submit"
              value="Valider"
            />
          </form>
          <p>Besoin d'un peu d'aide ? Scroll la page pour voir le cours ;)</p>
        </div>

        <div className="row" style={{ marginTop: 40, marginBottom: 40 }}>
          <div className="col-12 col-lg-4">
            <a className="all-button" href="/">
              Retour au menu
            </a>
          </div>
        </div>

        <div class="rappel">
          <h3>Rappel de cours :</h3>
          <p>A : 1</p>
          <p>B : 2</p>
          <p>C : 3</p>
          <p>D : 4</p>
          <p>E : 5</p>
          <p>F : 6</p>
          <p>G : 7</p>
          <p>H : 8</p>
          <p>I : 9</p>
          <p>J : 10</p>
          <p>K : 11</p>
          <p>L : 12</p>
          <p>M : 13</p>
          <p>N : 14</p>
          <p>O : 15</p>
          <p>P : 16</p>
          <p>Q : 17</p>
          <p>R : 18</p>
          <p>S : 19</p>
          <p>T : 20</p>
          <p>U : 21</p>
          <p>V : 22</p>
          <p>W : 23</p>
          <p>X : 24</p>
          <p>Y : 25</p>
          <p>Z : 26</p>
        </div>
        
      </div>
    );
  }
}

export default Alphabet;
